"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Flex = _styledComponents.default.div.withConfig({
  displayName: "Flex",
  componentId: "w1ylfy-0"
})(["", ";"], function (_ref) {
  var alignItems = _ref.alignItems,
    basis = _ref.basis,
    direction = _ref.direction,
    grow = _ref.grow,
    inline = _ref.inline,
    justifyContent = _ref.justifyContent,
    width = _ref.width,
    wrap = _ref.wrap;
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " ", " ", " display:", ";max-width:100%;"], alignItems && "align-items: ".concat(alignItems, ";"), basis && "flex-basis: ".concat(basis, ";"), direction && "flex-direction: ".concat(direction, ";"), grow && "flex-grow: ".concat(grow, ";"), justifyContent && "justify-content: ".concat(justifyContent, ";"), width && "width: ".concat(width, ";"), wrap && "flex-wrap: ".concat(wrap, ";"), inline ? 'inline-flex' : 'flex');
});
var _default = Flex;
exports.default = _default;